<template>
    <div>
        <div>
            <h4 class="first">Total Billings</h4>
            Sum of all invoices
            <strong>entered within the selected time period</strong>
            for all assignments matching the filters applied.
        </div>
        <div>
            <h4>Executive Search</h4>
            Sum of all Executive Search assignment invoices
            <strong>entered within the selected time period</strong>
            for all assignments matching the filters applied.
        </div>
        <div>
            <h4>Leadership Consulting</h4>
            Sum of all Leadership Consulting assignment invoices
            <strong>entered within the selected time period</strong>
            for all assignments matching the filters applied.
        </div>
        <div>
            <h4>Interim Management</h4>
            Sum of all Interim Management assignment invoices
            <strong>entered within the selected time period</strong>
            for all assignments matching the filters applied.
        </div>
        <!--
            <div>
			<h4>Strategy Billings</h4>
			Sum of all invoices
			<strong>entered within the selected time period</strong>
			for On Strategy company assignments.
		</div>
        -->
        <div>
            <h4>Teaming Value</h4>
            Sum of all invoices
            <strong>entered within the selected time period</strong>
            for all teaming assignments (i.e. assignments involving two or more Principals or Partners)
            that the selected entity (e.g. License, Partner, Practice Group, etc.) has participated in.
        </div>
        <p>
            Therefore if 25% of an invoice is attributed to a Partner, the full value of that invoice will
            appear in that Partner's Teaming Value metric.
        </p>
        <p>
            Note: Compare this metric to the Teaming Revenue metric. Note that at the Global level,
            Teaming Value and Teaming Revenue will match.
        </p>
        <div>
            <h4>Teaming Revenue</h4>
            The actual dollar figure for revenue received on invoices
            <strong>entered within the selected time period</strong>
            for an entity (e.g. License, Partner, Practice Group, etc.) on teaming assignments (i.e.
            assignments involving two or more Principals or Partners).
        </div>
        <p>
            Therefore if 25% of an invoice is attributed to a Partner, 25% of the value of that invoice
            will appear in that Partner's Teaming Revenue metric.
        </p>
        <p>
            Note: Compare this metric to the Teaming Value metric. Note that at the Global level, Teaming
            Revenue and Teaming Value will match.
        </p>
        <div>
            <h4>Date filter options</h4>
            <ul>
                <li>Activity - captures all entities with any activity (Invoice, Taken, Created or Status Change) within the date range.</li>
                <li>Date Taken - captures all entities with a Date Taken within the date range</li>
                <li>Invoice Date - captures all entities with an Invoice within the date range.</li>
                <li>Status Date - captures all entities with a Status change within the date range.</li>
            </ul>
        </div>
        <div>
            <h4>Filter option: Teaming Type</h4>
            <ul>
                <li>
                    Multiple License Teaming: limits results to assignments with at least two Partners from at
                    least two licenses
                </li>
                <li>
                    Single License / Multiple Office Teaming: limits results to assignments with at least two
                    Partners from at least two offices within a single license
                </li>
                <li>
                    Single Office Teaming: limits results to assignments with at least two Partners from
                    within a single office
                </li>
            </ul>
        </div>
        <div>
            <h4>Average Filled Job Value</h4>
            <span>
                <span>
                    Sum of Total Billings for all executive search assignments
                    <strong>whose status changed to Filled during the selected time period</strong>
                    divided by the number of assignments whose status changed to Filled during the selected
                    time period.
                </span>
            </span>
        </div>
        <p>
            The following types of assignments are excluded from the Average Filled Job Value calculation:
            search guarantee, additional placements from an existing assignment, and searches within the
            Director Search Subsector.
        </p>
        <div>
            <h4>Partners/Researchers/Administration</h4>
            <span>
                <span>
                    The number of Boydenians of each role type in the Directory on the
                    <strong>last day of the selected time period</strong>
                    .
                </span>
            </span>
        </div>
        <div>
            <h4>Assignments Taken</h4>
            The number of assignments
            <span>
                <span>
                    <strong>whose Date Taken is within the selected time period.</strong>
                </span>
            </span>
        </div>
        <p>
            <span>
                <span>
                    Important note: At the unfiltered Global level, this metric is straight forward. Once a
                    filter is applied, this metric may be a fraction, which reflects only the percentage of
                    teaming invoices attributable the license or Partners included. For example, if a Partner
                    accounts for 25% of an assignment, this metric will reflect 0.25 Assignments Taken.
                </span>
            </span>
        </p>
        <p>
            <span>
                <span>
                    Further, this metric can change as additional invoices are entered, even if the invoice
                    dates fall outside the selected time period.
                </span>
            </span>
        </p>
        <div>
            <h4>Teaming Taken</h4>
            The number of teaming assignments (i.e. assignments involving two or more Principals or
            Partners)
            <strong>whose Date Taken is within the selected time period.</strong>
        </div>
        <p>
            Important note: At the unfiltered Global level, this metric is straight forward. Once a filter
            is applied, this metric may be a fraction, which reflects only the percentage of teaming
            invoices attributable the license or Partners included. For example, if a Partner accounts for
            25% of an assignment, this metric will reflect 0.25 Teaming Taken.
        </p>
        <p>
            Further, this metric can change as additional invoices are entered, even if the invoice dates
            fall outside the selected time period.
        </p>
        <!--
        <div>
            <h4>Strategy Taken</h4>
            <span>
                <span>
                    <span>
                        <span>
                            <span>
                                <span>
                                    <span>
                                        The number of On Strategy company assignments
                                        <span>
                                            <span>
                                                <strong>whose Date Taken is within the selected time period.</strong>
                                            </span>
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>
                </span>
            </span>
        </div>
        <p>
            <span>
                <span>
                    Important note: At the unfiltered Global level, this metric is straight forward. Once a
                    filter is applied, this metric may be a fraction, which reflects only the percentage of
                    teaming invoices attributable the license or Partners included. For example, if a Partner
                    accounts for 25% of an assignment, this metric will reflect 0.25 Strategy Taken.
                </span>
            </span>
        </p>
        <p>
            <span>
                <span>
                    Further, this metric can change as additional invoices are entered, even if the invoice
                    dates fall outside the selected time period.
                </span>
            </span>
        </p>
        -->
        <div>
            <h4>Assignments Filled</h4>
            The number of
            <span><span>executive search</span></span>
            assignments
            <span>
                <span>
                    <strong>whose status changed to Filled during the selected time period.</strong>
                </span>
            </span>
        </div>
        <p>
            <span>
                <span>
                    Important note: At the unfiltered Global level, this metric is straight forward. Once a
                    filter is applied, this metric may be a fraction, which reflects only the percentage of
                    teaming invoices attributable the license or Partners included. For example, if a Partner
                    accounts for 25% of an assignment, this metric will reflect 0.25 Assignments Filled.
                </span>
            </span>
        </p>
        <div>
            <h4>Teaming Filled</h4>
            The number of teaming assignments (i.e. assignments involving two or more Principals or
            Partners)
            <strong>whose status changed to Filled during the selected time period.</strong>
        </div>
        <p>
            Important note: At the unfiltered Global level, this metric is straight forward. Once a filter
            is applied, this metric may be a fraction, which reflects only the percentage of teaming
            invoices attributable the license or Partners included. For example, if a Partner accounts for
            25% of an assignment, this metric will reflect 0.25 Teaming Filled.
        </p>
        <div>
            <h4>Time to Fill</h4>
            <span>
                <span>
                    <span>
                        The average number of days elapsed between the date the
                        <span>
                            <span>executive search</span>
                        </span>
                        assignment was taken and the date the assignment was filled for all assignments
                        <span>
                            <span>
                                <strong>whose status changed to Filled during the selected time period.</strong>
                            </span>
                        </span>
                    </span>
                </span>
            </span>
        </div>
        <div>
            <h4>Teaming Value and Teaming Revenue Examples</h4>
            <ul>
                <li>Total Billings for assignment: $100,000</li>
                <li>Partner A: 25%</li>
                <li>Partner B: 75%</li>
                <li>
                    Teaming Value of assignment for Partners:
                    <ul>
                        <li>Partner A: $100,000</li>
                        <li>Partner B: $100,000</li>
                    </ul>
                </li>
                <li>
                    Teaming Revenue of assignment for Partners:
                    <ul>
                        <li>Partner A: $25,000</li>
                        <li>Partner B: $75,000</li>
                    </ul>
                </li>
            </ul>
        </div>
        <div>
            <h4>Comparison Data</h4>
            <span>
                Many dashboard metrics include a comparison percentage to a previous period or point in
                time. The date used for this comparison data is always shifted back 12 months from the dates
                selected in the report parameters. For example:
            </span>
            <ul>
                <li>data for Q4 of the current year will be compared to data for Q4 of the prior year</li>
                <li>
                    data for 2Y (two years ending on the date the report is run), will be compared to a period
                    beginning 3 years ago and ending 1 year ago
                </li>
                <li>
                    headcount data (Partners, Researchers, Administration) compares the end date of the report
                    range to the same date 12 months prior
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    setup() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
@use "@/assets/css/globalVars.scss" as *;

h4 {
    margin-top: 14px;
    color: $boyden-blue;

    &.first {
        margin-top: inherit;
    }
}

ul li {
    margin: 0;
}
</style>
